import React, { useEffect, useState } from 'react';
import './blog.css';
import useStore from '../../../useStore';
import Loader from '../../elements/Loader/Loader';
import { useToast } from '../../../Contexts/Toast/toast.provider';

const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

const Blog = () => {
    const blog = useStore(state => state.blog);
    const loading = useStore(state => state.loading);
    const error = useStore(state => state.error);
    const fetchBlog = useStore(state => state.fetchBlog);
    const showToast = useToast();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        fetchBlog();
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [fetchBlog]);

    useEffect(() => {
        if (error) showToast('error', `❌ Error al cargar el Blog: ${error}`);
    }, [error, showToast]);

    if (loading) return <Loader />;

    const posts = blog[0]?.BlogComponent || [];

    if (posts.length === 0) return null;

    return (
        <div className="container blog-container">
            <h1 className="blog-main-title">Blog</h1>

            {posts.map((post, index) => {
                const bgUrl = strapiBase + (isMobile
                    ? (post.BlogImagenMobile?.url || post.BlogImagenEscritorio?.url || "")
                    : (post.BlogImagenEscritorio?.url || ""));

                const isEven = index % 2 === 0;

                return (
                    <div className="row blog-post-row" key={index}>
                        <div className={`col-md-6 d-flex flex-column justify-content-center ${isEven ? "" : "order-md-2"}`}>
                            <h2 className="blog-post-title">{post.BlogTitulo}</h2>
                            <p className="blog-post-desc">{post.BlogDescripcion}</p>
                        </div>
                        <div className={`col-md-6 ${isEven ? "order-md-2" : ""}`}>
                            <div
                                className="blog-post-img"
                                style={{ backgroundImage: `url(${bgUrl})` }}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Blog;
